import { motion } from "framer-motion";

// Section scroll reveal: fade + shift up
export const Reveal = ({ children, delay = 0, y = 40, className = "", ...props }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
    className={className}
    {...props}
  >
    {children}
  </motion.div>
);

// Overline label (mono, uppercase, tracked)
export const Overline = ({ children, className = "" }) => (
  <span
    className={`font-mono text-[11px] uppercase tracking-[0.28em] text-neutral-500 ${className}`}
  >
    {children}
  </span>
);
